import React, { useMemo } from "react";
import {Stage, Step} from "../../../api/model/scenario";
import './index.scss';
import {TravelQuotation} from "../../../model/quotation";
import { TravelStepContext } from "../../../contexts/TravelStepContext";
import {steps} from "../../../pages/TravelQuotationForm/steps";
import {useMediaQuery} from "@material-ui/core";

interface Props {
    step: Step,
    nextStepHandler: (quotation: TravelQuotation) => void;
    backStepHandler: (quotation: TravelQuotation, stepCallback?: (stage: Stage) => void) => void;
}

export const TravelStepComponent = ({step, nextStepHandler, backStepHandler}: Props) => {
    const isMobile = useMediaQuery('(max-width: 1023px)');

    const values = useMemo(() => ({
        backStepListener: backStepHandler,
        nextStepListener: nextStepHandler
    }), [backStepHandler, nextStepHandler])
    return (
        <TravelStepContext.Provider value={values}>
            <div className={isMobile ? 'travel-step-component-mobile' : 'travel-step-component'}>
                {React.createElement(steps[step.code], {
                    key: step.code,
                    step
                })}
            </div>
        </TravelStepContext.Provider>
    );
};